import { CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_FAIL } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONTENT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case CONTENT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case CONTENT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
